import { useEffect, useState } from "react";
import eventService from "../services/eventService";
export default function useEventTemplates() {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await eventService.getTemplates();
        setTemplates(res);
      } catch (err) {
        console.error("Error loading templates:", err);
      }
    };
    load();
  }, []);

  return templates;
}
